import * as aws from "aws-sdk";
import { awsRegion, awsIdentityPoolId, awsBucket } from "./config";
import { Buffer } from "buffer";
import {
  S3Response,
  S3UploadProgress,
} from "./types/contractAddress/s3.service";

export async function deleteToS3(
  fileName: string,
): Promise<aws.S3.DeleteObjectOutput> {
  return new Promise((resolve, reject) => {
    try {
      if (aws) {
        aws.config.region = awsRegion;
        aws.config.credentials = new aws.CognitoIdentityCredentials({
          IdentityPoolId: awsIdentityPoolId,
        });

        const s3 = new aws.S3();
        const params: aws.S3.DeleteObjectRequest = {
          Bucket: awsBucket,
          Key: `${fileName}`,
        };

        s3.deleteObject(
          params,
          (err: aws.AWSError, data: aws.S3.DeleteObjectOutput) => {
            if (data) {
              resolve(data);
            } else {
              reject(err);
            }
          },
        );
      }
    } catch (err) {
      throw err;
    }
  });
}

export async function uploadToS3(
  fileName: string,
  file: File | Buffer,
  key: string,
  type: string,
): Promise<S3Response> {
  return new Promise((resolve, reject) => {
    try {
      if (aws) {
        aws.config.region = awsRegion;
        aws.config.credentials = new aws.CognitoIdentityCredentials({
          IdentityPoolId: awsIdentityPoolId,
        });

        const s3 = new aws.S3({
          apiVersion: "2006-03-01",
          params: { Bucket: awsBucket },
        });

        const params: aws.S3.PutObjectRequest = {
          Bucket: awsBucket,
          Key: `${key}/${fileName}.${type}`,
          Body: file,
          ACL: "public-read",
        };

        s3.upload(params, (err: Error, data: S3Response) => {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        }).on("httpUploadProgress", (evt: S3UploadProgress) => {
          const progress = Math.round((evt.loaded / evt.total) * 100);
          // Upload progress: progress%
        });
      }
    } catch (err) {
      throw err;
    }
  });
}
